import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";

type AuthContext = {
  state:
    | { status: "loading" }
    | { status: "anonymous" }
    | { status: "authenticated"; user: { id: string; display_name: string; email: string | null; is_superuser: boolean } };
  requestMagicLink: (email: string) => Promise<void>;
  redeemMagicLink: (token: string) => Promise<void>;
  signOut: () => Promise<void>;
};

export interface RouterContext {
  auth: AuthContext;
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
